export const POS_PATH = '/salon/pos';

export const openPosInNewTab = () => {
  const url = `${window.location.origin}${POS_PATH}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const isPosPath = (pathname) => pathname.startsWith(POS_PATH);
